<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
    </div>
    <section class="hero">
        <div class="hero-body">
            <div class="container">
            <h1 class="title">
                Followup Jobs BP (สาขา {{ branchSelected }})
            </h1>
            </div>
        </div>
    </section>
    <section class="section" v-if="!openEdit">
        <div class="container">
            <table class="table is-striped" style="width:100%" v-show="dataAlready">
                <thead>
                    <tr>
                      <th><abbr title="runNo">ลำดับที่</abbr></th>
                      <th><abbr title="confirmTime">เวลารับรถ</abbr></th>
                      <th><abbr title="status">อยู่ขั้นตอน</abbr></th>
                      <th><abbr title="updateTime">เริ่มขั้นตอนนี้</abbr></th>
                      <th><abbr title="useTime">ใช้เวลาไปแล้ว</abbr></th>
                      <th><abbr title="startTime">เวลาที่นัดลูกค้า</abbr></th>
                      <th><abbr title="action"></abbr></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="car in carList" v-bind:key="car.id" >
                      <td>{{car.runNo}} <br><span class="car_info">({{car.licenseNo}})</span></td>
                      <td>{{car.confirmDate}}</td>
                      <td>{{car.status}}</td>
                      <td>{{car.updateDate}}</td>
                      <td>{{car.utcDiff}}</td>
                      <td>{{car.expectedDate}} {{car.expectedTime}}</td>
                      <td>
                        <button  class="button is-danger" v-on:click="closeJob($event, car.id, car.licenseNo)" >Close</button>
                      </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>

    <section class="section" v-if="openEdit">
        <div class="container">
            <h2 class="title is-4">แก้ไขข้อมูล Job<br>หมายเลข {{ editData.runNo }} ทะเบียน {{ editData.licenseNo }}</h2>
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">วันที่นัดลูกค้า</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" placeholder="0" v-model="editData.expectedDate">
                  </p>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">เวลาที่นัดลูกค้า</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" placeholder="0" v-model="editData.expectedTime">
                  </p>
                </div>
              </div>
            </div>
            <div class=" are-medium" style="text-align:center">
                <button class="button is-danger" v-on:click="cancelUpdate" >ยกเลิก</button>&nbsp;&nbsp;&nbsp;
                <button class="button is-info" v-on:click="updateJob" >{{btn_confirm_title}}</button>
            </div>
        </div>
      </section>
  </div>
</template>
<style>
.customerWait {
  color: #fd1880;
  background-color: #ffe9f3;
}
.banner {
  text-align: center;
  background-color: #000;
}
.hero-body {
  padding: 1.5rem 1.5rem !important;
}
.section {
  padding: 1rem .2rem !important;
}
td {
  font-size: 14px !important;
}
.car_info {
  color: #888;
  font-size: 12px;
}
</style>
<script>
export default {
  name: 'Home',
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
  },
  components: {
  },
  data: () => ({
    dataAlready: false,
    branch: [],
    branchSelected: '',
    branchCode: '',
    carId: '',
    carList: [],
    t: null,
    frommethod: '',
    currentTime: 0,
    editId: '',
    editData: [],
    openEdit: false,
    btn_confirm_title: 'บันทึก'
  }),
  mounted () {
    if (!this.$session.exists() || (typeof this.$session.get('vgroup') === 'undefined' || this.$session.get('vgroup') === '')) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
    let _this = this
    _this.currentTime = Date.now()
    _this.branch = this.$branchList
    const queryString = decodeURIComponent(window.location.search).replace('?liff.state=', '')
    const params = new URLSearchParams(queryString)
    _this.branchCode = params.get('branchCode')
    _this.branch.map((item) => {
      _this.branchSelected = (item.id === _this.branchCode) ? item.name : _this.branchSelected
      return true
    })
    _this.getCarList()
  },
  methods: {
    openForm (event, carId) {
      this.openEdit = true
      this.editId = carId
      this.editData = []
      this.editData = this.carList.filter((car) => { return carId === car.id })
      if (this.editData.length > 0) {
        this.editData = this.editData[0]
      }
    },
    cancelUpdate () {
      this.openEdit = false
      this.editId = ''
      this.editData = null
    },
    getCarList () {
      let _this = this
      _this.dataAlready = false
      this.$axios
        .get(`${this.$apiUrl}getJobsBPNotComplete?branch=${_this.branchCode}`)
        .then(response => {
          _this.dataAlready = true
          _this.carList = response.data

          _this.carList.sort((a, b) => {
            let keyA = a.utcDiff
            let keyB = b.utcDiff
            // Compare the 2 dates
            if (keyA > keyB) return -1
            if (keyA < keyB) return 1
            return 0
          })
        })
    },
    closeJob (event, carId, runNo) {
      if (!confirm('คุณต้องการ manual close งานทะเบียน ' + runNo)) {
        return false
      }
      let _this = this
      let params = {
        carId: carId
      }
      this.$axios
        .post(`${this.$apiUrl}closeJobBP`, params)
        .then(response => {
          _this.getCarList()
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FollowupBP.vue